import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';
import SelectFilter from 'components/Filters/SelectFilter';
import {default as DateRangeFilter} from 'components/Filters/DateRangeFilter';

interface PassedProps {
  setFilter: (field: string, value: any) => void;
  clearFilters: () => void;
  getFilters: any;
  featureOptions: any;
  statusOptions: any;
}

class StatusPageFilters extends React.Component<PassedProps> {
  render() {
    const filters = this.props.getFilters();

    return (
      <div className="BookingListFilters colab-row-space-between">
        <div className="colab-sidepadding-2">
          <SelectFilter
            label="Integrations"
            data={this.props.featureOptions}
            value={filters.feature}
            onChange={option => this.props.setFilter('feature', option)}
            multi={false}
          />
          <SelectFilter
            label="Status"
            data={this.props.statusOptions}
            value={filters.status}
            onChange={option => this.props.setFilter('status', option)}
          />
          <DateRangeFilter
            label="Created"
            fieldName="created"
            start={filters.createdStart}
            end={filters.createdEnd}
            onChange={(fieldName, date) => {
              this.props.setFilter(fieldName, date);
            }}
          />
        </div>
        <div>
          <Button clear onClick={this.props.clearFilters}>
            Clear all filters
          </Button>
        </div>
      </div>
    );
  }
}

export default StatusPageFilters;
